export default __webpack_public_path__ + "static/media/recent_post.2afadfee.png";